module.exports = __webpack_public_path__ + "static/media/bc_dashboard.14386e68.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ipd552/bc_dashboard.png
// module id = 184
// module chunks = 0